<script>
import HeaderTopbar from 'components/common/HeaderTopbar'
import TextButton from 'components/common/TextButton'

export default {
  name: 'product.consult',
  components: { HeaderTopbar, TextButton },

  methods: {
    toTrialPage() {
      this.$router.push({ name: 'trial' })
    }
  }
}
</script>

<template lang="pug">
section.solution-edu.dm-corp-page
  header-topbar(theme="invert" active-item="products"
    scroll-bg="#1C67FE" scroll-theshold="100" watch-scroll)

  section.above-the-fold
    .hero-image-container.main-container
      .hero-bg-icon
      .hero-image
      .hero-box
        h1.hero-title 格米倾亭智能心理倾诉亭
        .description 提供快捷、隐私、便利的校园心理轻咨询服务
        .intro-desc.card
          ul
            li.intro-item
              strong 快捷
              span 遇到烦恼即刻倾诉、及时解决，不再让负面情绪滚雪球
            li.intro-item
              strong 隐私
              span 提供封闭、隔音和舒适的倾诉空间，降低顾虑和病耻感
            li.intro-item
              strong 便利
              span 打破时空局限，节省场地空间，免除预约、排期等琐碎作业
      

  section.consult-section.core-modules-container
    .main-container
      .core-modules
        .core-module-image
        .module-steps-container
          h2.section-title 极简体验
          .section-sub-title 充分考虑青少年心理特点，仅需三步即可开始烦恼倾诉
          .module-steps
            .step-item 选择烦恼问题
            .step-arrows.dmico-consult-step-arrow
            .step-item 登录个人账号 
            .step-arrows.dmico-consult-step-arrow
            .step-item 等待电话接通

  section.consult-section.primary-bg.fuzhu-container
    .main-container
      .fuzhu-box
        .fuzhu-desc-container
          h2.section-title 智能辅助
          .section-sub-title 凝聚格米科技十年智慧结晶，实现心理倾诉智能化
          .intro-desc
            ul
              li.intro-item
                strong 智聊
                span 智能咨询辅助工具，协助快速诊断问题、提升服务品质
              li.intro-item
                strong 智连
                span 连接丰富的心理测评与自助资源，智能推送至个人账号
              li.intro-item
                strong 智管
                span 通过格米智能平台实现设备管理、数据互通、危机预警
        .fuzhu-image

  section.consult-section.service-container
    .main-container
      .service-box
        .service-image
        .service-desc-container
          h2.section-title 完善服务
          .section-sub-title 依靠格米专业团队，提供安装、培训、维护一条龙服务
          .welcome-text 
            p 欢迎联系格米专家团队，
            p 了解更多产品特性
        

  

  
</template>

<style lang="scss">
@import '../styles/variables';

$lightPurple: #3f45ba;

.solution-edu.dm-corp-page {
  margin-top: 0;

  .above-the-fold {
    padding-top: 60px;
    padding-bottom: 40px;
    background: linear-gradient(270deg, $bg-blue-gradient-light 0%, $primary-color 100%);

    .hero-image-container {
      padding-top: 120px;
      position: relative;
      height: 540px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: flex-start;
    }

    .hero-box {
      position: relative;
    }

    .hero-title {
      font-size: 38px;
      font-weight: 800;
      line-height: 100%;
      margin-bottom: 15px;
      color: #fff;
    }

    .description {
      color: #fff;
      font-size: 22px;
      line-height: 150%;
    }

    .intro-desc {
      margin-top: 60px;
    }

    .hero-bg-icon {
      @include bgImage;
      background-image: url(../assets/images/consult-bg-1.png);
      width: 330px;
      height: 330px;
      position: absolute;
      left: 280px;
      top: 30px;
      opacity: 0.2;
    }

    .hero-image {
      @include bgImage;
      background-image: url(../assets/images/consult-show-1.png);
      width: 600px;
      height: 470px;
      position: absolute;
      right: 30px;
      bottom: -10px;
    }
  }

  .consult-section {
    padding: 40px 0;

    .section-title {
      color: $primary-color;
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 30px;
    }

    .section-sub-title {
      margin-bottom: 30px;
    }

    .section-title + .section-sub-title {
      margin-top: -20px;
    }

    &.primary-bg {
      background: linear-gradient(270deg, $bg-blue-gradient-light 0%, $primary-color 100%);
      color: #fff;

      .section-title {
        color: #fff;
      }
    }

    &.gray-bg {
      background: #f0f1f6;
    }
  }

  .intro-desc {
    padding: 20px 0;
    .intro-item {
      strong {
        margin-right: 20px;
        font-size: 28px;
      }
    }

    .intro-item + .intro-item {
      margin-top: 30px;
    }

    &.card {
      padding: 30px;
      border-radius: 20px;
      background-color: white;
      box-shadow: 0 5px 20px transparentize(#fff, 0.6);

      .intro-item {
        strong {
          color: $primary-color;
        }
      }
    }
  }

  .core-modules-container {
    padding-bottom: 0;
  }

  .core-modules {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;

    .module-steps-container {
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: flex-start;

      .module-steps {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
      }

      .step-item {
        box-sizing: content-box;
        width: 2em;
        padding: 1em 1.5em;
        color: $primary-color;
        font-size: 18px;
        font-weight: bold;
        line-height: 1.4;
        border-radius: 15px;
        box-shadow: 0 5px 20px transparentize($lightPurple, 0.9);
      }

      .step-arrows {
        margin: 0 15px;
      }
    }

    .core-module-image {
      position: relative;
      margin-right: 100px;
      width: 576px;
      height: 550px;
      background: url(../assets/images/consult-show-2.png) no-repeat center/cover;
    }
  }

  .fuzhu-box {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;

    .fuzhu-image {
      position: relative;
      margin-left: 100px;
      width: 562px;
      height: 550px;
      background: url(../assets/images/consult-show-3.png) no-repeat center/cover;
    }
  }

  .service-box {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;

    .service-image {
      position: relative;
      margin-right: 100px;
      width: 500px;
      height: 550px;
      background: url(../assets/images/consult-show-4.png) no-repeat center/cover;
    }

    .welcome-text {
      font-size: 30px;
      font-weight: 600;
    }
  }
}
</style>
